const modifiedFields = ['selectedItem'];
const modifiedFieldCustom = {
  selectedItem: ['eventTemplateSq']
};

export default { modifiedFields, modifiedFieldCustom };
